import { brand } from 'config';
import bossMessages from './bossMessages';
import injectMessage from './injectMessage';

const generateBossMessage = (storeDetails, isExperimentForPickupCopyClarity = false) => {
  const {
    inStorePickupEligibility, curbsidePickupEligibility, bossAvailabilityMessage,
  } = storeDetails;
  const { label2, label3 } = bossMessages;
  let pickupLabel = isExperimentForPickupCopyClarity ? label3 : label2;

  if (!isExperimentForPickupCopyClarity) {
    if (inStorePickupEligibility && curbsidePickupEligibility) {
      pickupLabel += ` ${ bossMessages.bothInStoreAndCurbsideEligible}`;
    } else if (inStorePickupEligibility) {
      pickupLabel += ` ${ bossMessages.onlyInStoreEligible}`;
    } else if (curbsidePickupEligibility) {
      pickupLabel += ` ${ bossMessages.onlyCurbsideEligible}`;
    }
  } else {
    pickupLabel += brand === 'mcom' ? '.' : '!';
  }

  const topLineMsg = injectMessage(bossMessages.label1,
    { bossAvailabilityLabel: ((brand === 'mcom') ? bossAvailabilityMessage : '5-8 days') });

  // const pickupLabel = `${`${label1 + name}`} ${label2}`;
  return {
    topLineMsg, pickupLabel, value: 'Pickup', disabled: false,
  };
};

export default generateBossMessage;
